<div class="content-wrapper container-xxl p-0">
    <div class="content-body">

        <div id="user-profile">
            <div class="row">
                <div class="col-12">
                    <div class="card profile-header mb-2 banner"
                        [style]="'background-image:url('+agente.banner+');'">
                    </div>
                </div>
            </div>

            <div class="container position-relative cardPrincipal" id="cardFoto">
                <div class="card">
                    <div class="card-body">
                        <div class="card card-profile">
                            <div class="card-body">
                                <div class="profile-image-wrapper">
                                    <div class="profile-image">
                                        <img [src]="agente.photo" alt="Profile Picture" />
                                    </div>
                                </div>
                            </div>
                            <div class="card-body chico">
                                <div class="row ">
                                    <div class="col-12 col-sm-12 d-flex justify-content-center">
                                        <h2>
                                            <strong>{{agente.fullName}}</strong>
                                        </h2>
                                    </div>
                                    <div class="col-12 d-flex justify-content-center">
                                        <h4>
                                            <strong>{{agente.marketStall}}</strong>
                                        </h4>
                                    </div>
                                    <div class="col-12 ">
                                        <div class="row">
                                            <div class="col-2"></div>
                                            <div class="col-12 col-sm-4 mt-sm-1" *ngIf="agente.isWhatsApp === 1"><a
                                                    href="https://wa.me/52{{agente.phone}}" target='_blank'
                                                    class="btn btn-success btn-block " role="button"
                                                    style="font-weight: bolder;">
                                                    Whatsapp
                                                </a>
                                            </div>
                                            <div class="col-12 mt-1 mt-sm-1"
                                                [ngClass]="agente.isWhatsApp === 1 ? 'col-sm-4' : 'col-sm-8'"><a
                                                    href="tel:{{agente.phone}}" target='_blank'
                                                    class="btn btnDifu btn-block shadowInm" role="button"
                                                    (mouseenter)="onMouseEnterBtnDyn($event)"
                                                    (mouseleave)="onMouseOutBtnDyn($event)" style="font-weight: bolder;"
                                                    [ngStyle]="{'color':agente.colorAgent }">
                                                    Llamar
                                                </a>
                                            </div>
                                            <div class="col-2"></div>
                                        </div>


                                    </div>
                                </div>
                                <hr>
                                <div class="row">
                                    <div class="col-12 col-sm-6">
                                        EMAIL
                                        <h5>{{agente.email}}</h5>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        TELÉFONO
                                        <h5>{{agente.phone | slice:0:3
                                            }}-{{agente.phone | slice:3:6
                                            }}-{{agente.phone |
                                            slice:6:10}}</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body grande">
                                <div class="row">
                                    <div class="col-12">
                                        <h2>{{agente.fullName}}</h2>
                                    </div>
                                    <div class="col-12">
                                        <h4>{{agente.marketStall}}</h4>
                                    </div>
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-3" *ngIf="agente.isWhatsApp === 1"><a
                                                    href="https://wa.me/52{{agente.phone}}" target='_blank'
                                                    class="btn btn-success btn-block" role="button"
                                                    style="font-weight: bolder;">
                                                    Whatsapp
                                                </a>
                                            </div>
                                            <div class="col-3"><a href="tel:{{agente.phone}}" target='_blank'
                                                    class="btn btnDifu btn-block shadowInm" role="button"
                                                    (mouseenter)="onMouseEnterBtnDyn($event)"
                                                    (mouseleave)="onMouseOutBtnDyn($event)" style="font-weight: bolder;"
                                                    [ngStyle]="{'color':agente.colorAgent }">
                                                    Llamar
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 emailGrande">
                                        <div class="row">
                                            <div class="col-4">
                                                <strong>EMAIL</strong>
                                                <h5>{{agente.email}}</h5>
                                            </div>
                                            <div class="col-2">
                                            </div>
                                            <div class="col-3">
                                                <strong>TELÉFONO</strong>
                                                <h5>
                                                    {{agente.phone | slice:0:3
                                                    }}-{{agente.phone | slice:3:6
                                                    }}-{{agente.phone |
                                                    slice:6:10}}
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container" id="cardFoto">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-lg-6 col-xl-6 col-md-12 d-flex justify-content-center">
                                <ngb-carousel [interval]="5000" [pauseOnHover]="true" class="carr"
                                    style="height: fit-content; align-self: center;">

                                    <ng-template ngbSlide
                                        *ngFor="let img of agente.aboutImages;let indexOfelement=index;">
                                        <div class="carousel-img-wrapper" (click)="showGallery(indexOfelement)">
                                            <img [src]="img.path" class="sder img-fluid rounded"
                                                alt="Random first slide" />
                                        </div>
                                        <div class="carousel-caption"></div>
                                    </ng-template>

                                </ngb-carousel>
                            </div>




                            <div class="col-12 col-lg-6 col-xl-6 col-md-12 mt-1 mt-xl-0 mt-md-1 mt-lg-0">
                                <div class="row justify-content-between">
                                    <div class="col-12">
                                        <h3><strong>Acerca de mi</strong></h3>
                                        <span style="white-space: pre-line;">
                                            {{agente.aboutMe}}
                                        </span>
                                    </div>
                                    <div class="col-12 mt-1">
                                        <h3><strong>Contacto</strong></h3>
                                        <div class="row">

                                            <!-- <div
                                                class="mr-1 col-3 col-sm-1 col-xl-1 col-md-1 col-lg-1 mb-1 mb-xl-0 mb-md-0 mb-lg-0">
                                                <a href="mailto:{{agente.email}}"
                                                    class="btn btn-lg btn-icon rounded-circle btn-warning "><span
                                                        [data-feather]="'mail'" [size]="24"></span></a>
                                            </div> -->

                                            <div class="col-6 col-md-4 col-xl-4 col-lg-4 mt-1"
                                                *ngIf="agente.isWhatsApp === 1"><a
                                                    href="https://wa.me/52{{agente.phone}}" target='_blank'
                                                    class="btn btn-success btn-block" role="button"
                                                    style="font-weight: bolder;">
                                                    Escribir por Whatsapp
                                                </a>
                                            </div>

                                            <div class="col-6 col-md-4 col-xl-4 col-lg-4 mt-1">
                                                <button type="button" class="btn btn-block btnDifu shadowInm"
                                                    (mouseenter)="onMouseEnterBtnDyn($event)"
                                                    (mouseleave)="onMouseOutBtnDyn($event)" rippleEffect
                                                    [vcdDownloadVCard]="vCard" style="font-weight: bolder; "
                                                    [ngStyle]="{'color':agente.colorAgent }">
                                                    Guardar contacto</button>
                                            </div>

                                            <div class="col-6 col-md-4 col-xl-4 col-lg-4 mt-1">
                                                <button type="button" class="btn btn-block btnDifu shadowInm"
                                                    (mouseenter)="onMouseEnterBtnDyn($event)"
                                                    (mouseleave)="onMouseOutBtnDyn($event)" rippleEffect
                                                    style="font-weight: bolder; "
                                                    [ngStyle]="{'color':agente.colorAgent }"
                                                    (click)="modalOpenLink(modallink)">
                                                    Compartir</button>
                                            </div>

                                            <div class="col-6 col-md-4 col-xl-4 col-lg-4 mt-1">
                                                <a [href]="subdomain+'.inmoapp.mx'"
                                                    class="btn btn-block btnDifu shadowInm" target='_blank'
                                                    (mouseenter)="onMouseEnterBtnDyn($event)"
                                                    (mouseleave)="onMouseOutBtnDyn($event)" style="font-weight: bolder;"
                                                    [ngStyle]="{'color':agente.colorAgent }">
                                                    Sitio web
                                                </a>
                                            </div>

                                            <div class="col-6 col-md-4 col-xl-4 col-lg-4 mt-1"
                                                *ngFor="let button of agente.buttons">
                                                <a [href]="button.url" class="btn btn-block btnDifu shadowInm"
                                                    target='_blank' (mouseenter)="onMouseEnterBtnDyn($event)"
                                                    (mouseleave)="onMouseOutBtnDyn($event)" style="font-weight: bolder;"
                                                    [ngStyle]="{'color':agente.colorAgent }">
                                                    {{button.description}}
                                                </a>
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container" id="cardFoto">
                <div class="card">
                    <div class="card-body">
                        <div class="row ">
                            <div class="col-12 col-lg-4 col-xl-4 col-md-6 mt-1 mt-xl-0 mt-md-0 mt-lg-0 mb-1"
                                *ngIf="agente.fbUrlRealEstate">
                                <h3 style="text-align: center;"><strong>Encuéntranos en Facebook</strong></h3>
                                <div class="row text-md-center text-md-left">
                                    <div class="col-12">
                                        <div id="frameFace" class="d-flex justify-content-center"></div>
                                    </div>
                                </div>

                            </div>

                            <div class="col-12 col-lg-3 col-xl-3 col-md-6">
                                <div class="w-100 d-flex justify-content-center">
                                    <img [src]="agente.logoRealEstate" class="rounded" alt="logoRealEstate"
                                        style="width: inherit;" />
                                </div>
                                <h3><strong>Mi oficina se ubica en:</strong></h3>
                                <p class="h4">
                                    {{agente.streetRealEstate}} #{{agente.noExtRealEstate}}, <span
                                        *ngIf="agente.noIntRealEstate !== null">Int. {{agente.noIntRealEstate}},</span>
                                    {{agente.suburbRealEstate}} C.P: {{agente.postalCodeRealEstate}},
                                    {{agente.stateRealEstate}}, {{agente.provinceRealEstate}}.
                                </p>
                                <br>
                                <h3><strong>Teléfono(s) de oficina:</strong></h3>
                                <p>
                                    <span class="h4"
                                        *ngIf="agente.phone1RealEstate !== null && agente.phone1RealEstate !== ''"> <a
                                            [href]="'tel:'+agente.phone1RealEstate" class="dec">
                                            {{agente.phone1RealEstate | slice:0:3
                                            }}-{{agente.phone1RealEstate | slice:3:6
                                            }}-{{agente.phone1RealEstate |
                                            slice:6:10}}</a><button *ngIf="agente.isWhatsApp1RealEstate === '1'"
                                            type="button" class="btn btn-icon btn-icon rounded-circle btn-flat-success"
                                            rippleEffect>
                                            <span [data-feather]="'message-circle'"></span></button></span>
                                    <ng-container *ngIf="agente.isWhatsApp1RealEstate">
                                        <a href="https://wa.me/52{{agente.phone1RealEstate}}" style="margin-left:5px;">
                                            <svg style="color: #25D366;" xmlns="http://www.w3.org/2000/svg" width="20"
                                                height="20" fill="#25D366" class="whatsapp" viewBox="0 0 16 16">
                                                <path
                                                    d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
                                                    fill="#25D366"></path>
                                            </svg>
                                        </a>

                                    </ng-container>

                                    <br>
                                    <span class="h4"
                                        *ngIf="agente.phone2RealEstate !== null && agente.phone2RealEstate !== ''"><a
                                            [href]="'tel:'+agente.phone2RealEstate" class="dec">
                                            {{agente.phone2RealEstate | slice:0:3
                                            }}-{{agente.phone2RealEstate | slice:3:6
                                            }}-{{agente.phone2RealEstate |
                                            slice:6:10}}</a><button *ngIf="agente.isWhatsApp2RealEstate === '1'"
                                            type="button" class="btn btn-icon btn-icon rounded-circle btn-flat-success"
                                            rippleEffect>
                                            <span [data-feather]="'message-circle'"></span></button></span>
                                    <ng-container *ngIf="agente.isWhatsApp2RealEstate">
                                        <a href="https://wa.me/52{{agente.phone2RealEstate}}" style="margin-left:5px;">
                                            <svg style="color: #25D366;" xmlns="http://www.w3.org/2000/svg" width="20"
                                                height="20" fill="#25D366" class="whatsapp" viewBox="0 0 16 16">
                                                <path
                                                    d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
                                                    fill="#25D366"></path>
                                            </svg>
                                        </a>

                                    </ng-container>
                                    <br>
                                    <span class="h4"
                                        *ngIf="agente.phone3RealEstate !== null && agente.phone3RealEstate !== ''"><a
                                            [href]="'tel:'+agente.phone3RealEstate" class="dec">
                                            {{agente.phone3RealEstate | slice:0:3
                                            }}-{{agente.phone3RealEstate | slice:3:6
                                            }}-{{agente.phone3RealEstate |
                                            slice:6:10}}</a><button *ngIf="agente.isWhatsApp3RealEstate === '1'"
                                            type="button" class="btn btn-icon btn-icon rounded-circle btn-flat-success"
                                            rippleEffect>
                                            <span [data-feather]="'message-circle'"></span></button></span>
                                    <ng-container *ngIf="agente.isWhatsApp3RealEstate">
                                        <a href="https://wa.me/52{{agente.phone2RealEstate}}" style="margin-left:5px;">
                                            <svg style="color: #25D366;" xmlns="http://www.w3.org/2000/svg" width="20"
                                                height="20" fill="#25D366" class="whatsapp" viewBox="0 0 16 16">
                                                <path
                                                    d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
                                                    fill="#25D366"></path>
                                            </svg>
                                        </a>

                                    </ng-container>
                                    <br>
                                </p>


                                <h3><strong>Email:</strong></h3>
                                <p class="h4"> <a class="dec"
                                        [href]="'mailto:'+agente.emailRealEstate">{{agente.emailRealEstate}}</a></p>
                            </div>

                            <div class="col-12 col-lg-5 col-xl-5 col-md-12 d-flex justify-content-center ">
                                <ngb-carousel [interval]="5000" [pauseOnHover]="true" class="carr">

                                    <ng-template ngbSlide
                                        *ngFor="let img of agente.agentImages;let indexOfelement=index;">
                                        <div class="carousel-img-wrapper" (click)="showGalleryAgent(indexOfelement)">
                                            <img [src]="img.path" class="sder img-fluid rounded"
                                                alt="Random first slide" />
                                        </div>
                                        <div class="carousel-caption"></div>
                                    </ng-template>

                                </ngb-carousel>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="container" id="cardFoto">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-lg-6 col-xl-6 col-md-12 mt-1 mt-xl-0 mt-md-0 mt-lg-0 mb-1"
                                *ngIf="agente.logoRealEstate !== null">
                                <div class="carousel-img-wrapper">
                                    <img [src]="url + agente.logoRealEstate" class="sder img-fluid rounded"
                                        alt="Random first slide" />
                                </div>
                            </div>
                            <div class="col-12 col-lg-6 col-xl-6 col-md-12">
                                <h3><strong>Mi oficina se ubica en:</strong></h3>
                                <p class="h4">
                                    {{agente.streetRealEstate}} {{agente.noExtRealEstate}}, <span
                                        *ngIf="agente.noIntRealEstate !== null">{{agente.noIntRealEstate}},</span>
                                    {{agente.suburbRealEstate}}, C.P. {{agente.postalCodeRealEstate}},
                                    {{agente.stateRealEstate}}, {{agente.provinceRealEstate}}.
                                </p>
                                <br>
                                <h3><strong>Teléfono(s) de oficina:</strong></h3>
                                <p>
                                    <span class="h4"
                                        *ngIf="agente.phone1RealEstate !== null && agente.phone1RealEstate !== ''"> <a
                                            [href]="'tel:'+agente.phone1RealEstate" class="dec">
                                            {{agente.phone1RealEstate}}</a><button
                                            *ngIf="agente.isWhatsApp1RealEstate === '1'" type="button"
                                            class="btn btn-icon btn-icon rounded-circle btn-flat-success" rippleEffect>
                                            <span [data-feather]="'message-circle'"></span></button></span> <br>
                                    <span class="h4"
                                        *ngIf="agente.phone2RealEstate !== null && agente.phone2RealEstate !== ''"><a
                                            [href]="'tel:'+agente.phone2RealEstate" class="dec">
                                            {{agente.phone2RealEstate}}</a><button
                                            *ngIf="agente.isWhatsApp2RealEstate === '1'" type="button"
                                            class="btn btn-icon btn-icon rounded-circle btn-flat-success" rippleEffect>
                                            <span [data-feather]="'message-circle'"></span></button></span> <br>
                                    <span class="h4"
                                        *ngIf="agente.phone3RealEstate !== null && agente.phone3RealEstate !== ''"><a
                                            [href]="'tel:'+agente.phone3RealEstate" class="dec">
                                            {{agente.phone3RealEstate}}</a><button
                                            *ngIf="agente.isWhatsApp3RealEstate === '1'" type="button"
                                            class="btn btn-icon btn-icon rounded-circle btn-flat-success" rippleEffect>
                                            <span [data-feather]="'message-circle'"></span></button></span> <br>
                                </p>


                                <h3><strong>Email:</strong></h3>
                                <p class="h4"> <a class="dec"
                                        [href]="'mailto:'+agente.emailRealEstate">{{agente.emailRealEstate}}</a></p>
                            </div>

                        </div>
                    </div>
                </div>
            </div> -->
        </div>

    </div>
    <ng-container *ngIf="galleryImages.length > 0">
        <ngx-gallery #gallery [options]="galleryOptions" [images]="galleryImages" class="ngx-gallery">
        </ngx-gallery>
    </ng-container>

    <ng-container *ngIf="galleryImagesAgent.length > 0">
        <ngx-gallery #galleryAgent [options]="galleryOptions" [images]="galleryImagesAgent" class="ngx-gallery">
        </ngx-gallery>
    </ng-container>
</div>

<ng-template #modallink let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">Copiar enlace</h4>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <div class="row">
            <div class="col-1"></div>
            <div class="col-7">
                <div class="form-group">
                    <label for="basicInput">Enlace</label>
                    <input class="form-control" [(ngModel)]="urlShareCopy" />
                </div>
            </div>
            <div class="col-3">
                <button type="button" [cdkCopyToClipboard]="urlShareCopy" ngbTooltip="Copiado en portapapeles"
                    triggers="click:blur" class="btn btn-primary" style="margin-top: 22px;" rippleEffect>
                    Copiar
                </button>
            </div>
        </div>
    </div>
</ng-template>